import { cn } from '../common/utils';
import { ContainerMain } from '../components/layout/ContainerMain';
import FilterPresetEditorSidebar from '../filterPreset/FilterPresetEditorSidebar';
import SidebarAiAgent from '../screens/help/SidebarAiAgent';
import ActualityMainContentView from './ActualityMainContentView';
import FeedHeader from './FeedHeader';
import ActualityHeatmapBucketsSidebar from './sidebar/ActualityHeatmapBucketsSidebar';
import FeedCommonInfoSidebar from './sidebar/FeedCommonInfoSidebar';
import FeedEventsSidebar from './sidebar/FeedEventsSidebar';
import FeedLocationSidebar from './sidebar/FeedLocationSidebar';
import FeedMainSidebar from './sidebar/FeedMainSidebar';
import FeedMenuSidebar from './sidebar/FeedMenuSidebar';

export type ActualityLayoutProps = {
  hasHeader: boolean;
};

const ActualityLayout: React.FC<ActualityLayoutProps> = props => {
  return (
    <>
      {props.hasHeader && <FeedHeader />}

      <ContainerMain data-component="ActualityLayout">
        <div className={cn('sidebar-wrapper side-left flex')}>
          <FeedMenuSidebar />
          <FeedMainSidebar />
          <FilterPresetEditorSidebar />
          <FeedEventsSidebar />
          <ActualityHeatmapBucketsSidebar />
          {/* <ActualityLevel3Sidebar /> */}
        </div>

        <ActualityMainContentView />

        <div
          className={cn(
            'sidebar-wrapper side-right',
            'flex',
            'border-app-panel-dark',
            'ltr:border-l rtl:border-r',
          )}
        >
          <FeedLocationSidebar />
          <FeedCommonInfoSidebar />
          <SidebarAiAgent />
        </div>
      </ContainerMain>
    </>
  );
};

export default ActualityLayout;
